module.exports = __webpack_public_path__ + "static/media/FivePhasesMountainINTA0020_design_clean_v001.79460c26.webp";